
<app-slider></app-slider>
<div class="section">
    <div class="container">
          
    <h5 class="pink-text">About the project</h5><hr>
    <p *ngFor="let item of about">
        {{item.para}}
    </p>
    </div>
</div>